import {
    filterBlocks,
    open,
    closeAll
} from '../utils/helpers';

/**
 * Returns content to append to the blocks panel
 * 
 * @param {Object} editor
 * @param {String} pfx style prefix
 * @param {Object} filters
 * 
 * @returns HTMLElement
 */

export default (editor, pfx, filters) => {
    const $ = editor.$;
    const bm = editor.Blocks;
    let primaryFiltersEl = '';
    let secondaryFiltersEl = '';

    filters.forEach(filter => {
        primaryFiltersEl += `<div data-filter="${filter.filter}">
                ${filter.filter} ${filter.premium ? ' <i class="fa fa-lock"></i>' : ''}
            </div>`;
        let subChildren = '';
        filter.secondary && filter.secondary.forEach(subfilter => {
            subChildren += `<div data-filter="${subfilter}">${subfilter}</div>`
        });
        secondaryFiltersEl += `<div data-parent="${filter.filter}" style="display:none">${subChildren}</div>`
    });

    const blocksEl = $(`<div id="${pfx}pn-add-container" class="${pfx}fadein">
            <div id="${pfx}pn-add-primary">${primaryFiltersEl}</div>
            <div id="${pfx}pn-add-secondary">${secondaryFiltersEl}</div>
            <div class="${pfx}pn-content">
                <div class="${pfx}pn-content-header" data-category="Blocks"></div>
                <div style="padding:10px;" class="${pfx}assets-search"><input class="tm-input sm" style="width:100%;padding:10px;border-radius:5px;" type="search" placeholder="Search blocks..."></div>
            </div>
        </div>`);

    editor.on('load', () => {
        blocksEl.primaryFilter = filterPrimary(bm, bm.getAll(), 'blocks');
    });

    const primaryFiltersObject = blocksEl.find(`#${pfx}pn-add-primary div`);
    const secondaryFiltersObject = blocksEl.find(`#${pfx}pn-add-secondary div`);
    const blocks = blocksEl.find(`.${pfx}pn-content`);
    const secondaryFiltersItems = secondaryFiltersObject.children();
    const secondaryFiltersFirst = secondaryFiltersObject.first();
    const firstSiblings = secondaryFiltersFirst.siblings();

    primaryFiltersObject.get(1).setAttribute('data-active', true);
    firstSiblings.get(0).style.display = 'block';

    primaryFiltersObject.on('click', function (e) {
        if (this.getAttribute('data-active') !== 'true') {
            const query = this.getAttribute('data-filter');
            closeAll(primaryFiltersObject);
            closeAll(secondaryFiltersItems);
            open(this);
            showSecondaryFilters(this, secondaryFiltersFirst);
            showSecondaryFilters(this, firstSiblings);
            blocksEl.primaryFilter = filterPrimary(bm, bm.getAll(), query);
            blocks.children().get(0).setAttribute('data-category', query);
        }
    });
    secondaryFiltersItems.on('click', function (e) {
        if (this.getAttribute('data-active') !== 'true') {
            closeAll(secondaryFiltersItems);
            open(this);
            filterSecondary(bm, blocksEl.primaryFilter, this.getAttribute('data-filter'));
        }
    });

    const input = blocksEl.find('input');
    input.on('keyup', e => {
        closeAll(secondaryFiltersItems);
        filterLast(bm, blocksEl.primaryFilter || bm.getAll(), e.target.value);
    });

    blocks.append(bm.render());
    return blocksEl;
}

/**
 * Filter based on primary filter
 * 
 * @param {Object} bm Block Manager
 * @param {Object} all Superset to filter
 * @param {String} query From data-filter
 */
const filterPrimary = (bm, all, query) => {
    if (query == 'Blocks') {
        return filterBlocks(bm, all, (blocks) => {
            return !blocks.get('category-primary'); //blocks.get('category') && 
        });
    } else {
        return filterBlocks(bm, all, (blocks) => {
            return blocks.get('category-primary') == query;
        });
    }
}

/**
 * Filter based on secondary filter
 * 
 * @param {Object} bm Block Manager
 * @param {Object} filtered Superset to filter
 * @param {String} query From data-filter
 */
const filterSecondary = (bm, filtered, query) => {
    return query === 'All' ? filtered : filterBlocks(bm, filtered, (blocks) => {
        return blocks.get('category-secondary') == query;
    });
}

/**
 * Filter based on block label
 * 
 * @param {Object} bm Block Manager
 * @param {Object} filtered Superset to filter
 * @param {String} query From data-filter
 */
const filterLast = (bm, filtered, query) => {
    return filterBlocks(bm, filtered, (blocks) => {
        return blocks.get('label').toLowerCase().indexOf(query.toLowerCase()) > -1;
    });
};

/**
 * Show secondary filters for primary filter
 * 
 * @param {HTMLElement} el clicked element
 * @param {Oject} secondaryFiltersObject
 */
const showSecondaryFilters = (el, secondaryFiltersObject) => {
    secondaryFiltersObject.each((idx, model) => {
        if (model.getAttribute('data-parent') == el.getAttribute('data-filter'))
            model.style.display = 'block';
        else if (!model.getAttribute('data-parent')) return;
        else model.style.display = 'none';
    });
}